import React, { ComponentProps, FunctionComponent } from "react";

const MinimizeIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.143 5.99979C15.143 6.47306 14.7589 6.85714 14.2856 6.85714H10.0004C9.52715 6.85714 9.14307 6.47306 9.14307 5.99979V1.71465C9.14307 1.24137 9.52715 0.85729 10.0004 0.85729C10.4737 0.85729 10.8578 1.24137 10.8578 1.71465V3.93065L14.5372 0.251298C14.8723 -0.0837661 15.4146 -0.0837661 15.7489 0.251298C16.084 0.586363 16.084 1.12873 15.7489 1.4638L12.0695 5.14315H14.2855C14.7588 5.14315 15.1429 5.52723 15.1429 6.00051L15.143 5.99979Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.4638 15.7487C1.12873 16.0838 0.586363 16.0838 0.251298 15.7487C-0.0837661 15.4137 -0.0837661 14.8713 0.251298 14.537L3.93065 10.8576H1.71465C1.24137 10.8576 0.85729 10.4735 0.85729 10.0003C0.85729 9.52697 1.24137 9.14288 1.71465 9.14288H5.99979C6.47306 9.14288 6.85714 9.52697 6.85714 10.0003V14.2854C6.85714 14.7587 6.47306 15.1428 5.99979 15.1428C5.52651 15.1428 5.14243 14.7587 5.14243 14.2854V12.0694L1.4638 15.7487Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(MinimizeIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
